const validateDuplicatedContacts = (field, recipients) =>
  recipients.filter(recipient =>
    recipient.value === field.value && recipient.email === field.email).length > 1;

const validateDuplicatedEmail = (field, recipients) =>
  recipients.filter(
    recipient => recipient.value === field.value || recipient.email === field.value
  ).length > 1;

const validateDuplicated = (field, recipients) => {
  if (field.type === 'email') {
    return validateDuplicatedEmail(field, recipients);
  }

  return validateDuplicatedContacts(field, recipients);
};

const isValidEmail = email => /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email);

export default values => {
  const errors = {};
  if (!values.recipients) return {};

  const { recipients } = values;

  const recipientsArrayErrors = [];
  recipients.forEach((field, index) => {
    if (!field.value) {
      recipientsArrayErrors[index] = { value: 'Empty field value' };
    } else if (field.type === 'email' && !isValidEmail(field.value)) {
      recipientsArrayErrors[index] = { value: 'Please input a valid email address or select a contact' };
    } else if (validateDuplicated(field, recipients)) {
      recipientsArrayErrors[index] = { value: 'A recipient email must be unique' };
    }
  });

  if (recipientsArrayErrors.length) {
    errors.recipients = recipientsArrayErrors;
  }

  return errors;
};
